// extracted by mini-css-extract-plugin
module.exports = {"multipleButtonWrapper":"MultipleButton_multipleButtonWrapper__1Uh61","separateWithBorder":"MultipleButton_separateWithBorder__1khaN"};